import React, { useState, useEffect, useRef } from "react";
import "./DrawWithAIButton.css";
import sparkleIcon from "../../assets/Sparkle.svg"; // adjust path as needed
import { setAutoDraw, setDesignStep, setAutoDrawData, setNovaPoints, setNovaPointConnections, setNovaLines } from "../../Actions/ApplicationStateAction";
import withReactContent from "sweetalert2-react-content";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchWrapper } from "../../app/RomeDataManager";
import * as THREE from "three";
import { buildPointConnections } from "../../utils/novaConnections";

const MySwal = withReactContent(Swal);

const DrawWithAIButton = ({ }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const timeoutRef = useRef(null);

  // Automatically clear message after 3 seconds
  useEffect(() => {
    if (message) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setMessage(null);
      }, 5000);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [message]);

  const autoDrawData = useSelector(state => state.ApplicationState.autoDrawData);
  const floorplanId = useSelector(state => state.ApplicationState.floorplanId);


  

  const handleAutoDraw = async () => {
    MySwal.fire({
      title: "Are you sure you want to go Auto-draw?",
      html: `
          <p>Your current will be deleted and new one will be drawn</p>
        `,
      confirmButtonText: "Proceed",
      cancelButtonText: "Go Back",
      showCancelButton: true,
      showCloseButton: true,
      reverseButtons: true, // This swaps the button positions
      customClass: {
        title: "swal2-title-custom",
        htmlContainer: "swal2-html-custom",
        actions: "swal2-actions-custom",
        confirmButton: "swal2-confirm-button-custom",
        cancelButton: "swal2-cancel-button-custom",
      },
      width: "350px",
      padding: "24px",
      borderRadius: "12px",
      backdrop: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setDesignStep(2));
        dispatch(setAutoDraw(true));
        // If autoDrawData is null, check Nova endpoint

        if (!autoDrawData && floorplanId) {
          setLoading(true);
          try {
            const checkResponse = await fetchWrapper.get(
              `/floorplans/check_nova_draw_data/${floorplanId}`
            );
            
            if (checkResponse.data?.nova_status === "completed" && checkResponse.data?.nova_draw_data) {
              const parsedData = JSON.parse(checkResponse.data.nova_draw_data);
              dispatch(setAutoDrawData(parsedData));
              if (parsedData) {
                const pointSet = new Set();
                const novaPointsArray = [];

                if (parsedData.lines && parsedData.lines.length > 0) {
                  parsedData.lines.forEach(line => {
                    if (line.startPoint) {
                      const startKey = `${line.startPoint.x},${line.startPoint.y},${line.startPoint.z}`;
                      if (!pointSet.has(startKey)) {
                        pointSet.add(startKey);
                        novaPointsArray.push(new THREE.Vector3(
                          line.startPoint.x,
                          line.startPoint.y,
                          line.startPoint.z
                        ));
                      }
                    }
                    if (line.endPoint) {
                      const endKey = `${line.endPoint.x},${line.endPoint.y},${line.endPoint.z}`;
                      if (!pointSet.has(endKey)) {
                        pointSet.add(endKey);
                        novaPointsArray.push(new THREE.Vector3(
                          line.endPoint.x,
                          line.endPoint.y,
                          line.endPoint.z
                        ));
                      }
                    }
                  });
                }

                // Convert to JSON structure with IDs
                const novaPoints = novaPointsArray.map((point, index) => ({
                  id: index,
                  point: new THREE.Vector3(point.x, point.y, point.z),
                  x: point.x,
                  y: point.y,
                  z: point.z
                }));

                // Build point connections from lines
                const connections = buildPointConnections(parsedData.lines, novaPoints);

                // Store nova lines with their types
                const novaLines = parsedData.lines || [];

                dispatch(setNovaPoints(novaPoints));
                dispatch(setNovaPointConnections(connections));
                dispatch(setNovaLines(novaLines));
                //dispatch(setPoints(novaPoints));
              }
              console.log("Nova draw data loaded and set.");
              setMessage(null)
            } else {
              if (checkResponse.data?.nova_status === "processing" || checkResponse.data?.nova_status === "queued"){
                setMessage("Our AI is working on your image. This usually takes a few minutes. Check back shortly")
              }
              if (checkResponse.data?.nova_status === "failed" || checkResponse.data?.nova_status === "retrying"){
                setMessage("Oops! Something went wrong while processing your image.")
              }
              console.warn("No nova_draw_data found or status not completed.");
            }

          } catch (error) {
            console.error("Error checking Nova draw data:", error);
            MySwal.fire({
              icon: "error",
              title: "Failed to load AI drawing",
              text: "Could not fetch AI drawing data. Please try again later.",
            });
          } finally {
            setLoading(false);
          }
        }
        // dispatch(setStoreLines([]));
        console.log("Auto draw set to true");
      }
    });
    //window.GAEvent("DrawTool", "ButtonClicked", "BackToDrawing");
  };

  return (
    <div className="ai-main-div">
      <button className="draw-ai-btn" onClick={handleAutoDraw} disabled={loading}>
        <img src={sparkleIcon} alt="sparkle" className="draw-ai-icon" />
        <span className="draw-ai-label">{loading ? "Loading..." : "Draw with AI"}</span>
      </button>
      {
        message ? 
          <p>{message}</p>
          :
          null
      }
    </div>
  );
};

export default DrawWithAIButton;
